import React from 'react';
import './OpalStepper.css';

const OpalStepper = ({ steps = [], step = 0, activeColor, onClick }) => {
  return (
    <div className="stepper-wrapper"
        style={{ '--active-color': activeColor }}>
      <div className="stepper-line-bg" />
      <div className="stepper-container">
        {steps.map((label, index) => (
          <div className="step-item-wrapper" key={index}>
            <div
              className={`step-item ${step === index ? 'active' : ''}`}
              onClick={() => onClick?.(index)}
            >
              <div className="step-circle">{index + 1}</div>
              <div className="step-label">{label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OpalStepper;
